<template>
  <div>
    <h1>Приміщення</h1>
    <b-row cols="1">
      <b-col cols="4">
        <b-form-datepicker v-model="date" class="mb-2"></b-form-datepicker>
      </b-col>
      <b-col cols="1">
        <facility-booker
          v-on:error="updatePage(false)"
          v-on:success="updatePage(true)"
        />
      </b-col>
    </b-row>
    <h2 class="mt-5" v-if="!schedule.length">На цей день записів немає :(</h2>
    <b-table
      v-if="schedule.length"
      class="mt-3"
      striped
      responsive
      :fields="fields"
      :items="schedule"
    >
      <template #cell(time)="row">
        {{ row.item.time | moment }}
      </template>
      <template #cell(club_id)="row">
        {{ row.item.club_id | toClub }}
      </template>
      <template #cell(edit)="row">
        <b-button
          size="sm"
          variant="outline-success"
          @click="openPatcher(row.item)"
        >
          Редагувати
        </b-button>
      </template>
    </b-table>
    <Alert
      :class="this.class"
      v-bind:text="this.AlertText"
      v-bind:activErr="this.activErr"
    ></Alert>
    <facility-patcher v-bind:visit="currentRecord" />
  </div>
</template>

<script>
import moment from "moment";
import FacilityBooker from "@/components/modals/FacilityBooker";
import FacilityPatcher from "@/components/Facilities/FacilityPatcher";
import { mapActions } from "vuex";
import Alert from "@/components/Toasts/Alert";
export default {
  name: "Facilities",
  components: {
    FacilityBooker,
    FacilityPatcher,
    Alert,
  },
  data: function () {
    return {
      schedule: [],
      date: null,
      fields: [
        { key: "facility", label: "Приміщення" },
        { key: "specialist", label: "Спеціаліст" },
        { key: "time", label: "Час" },
        { key: "client", label: "Клієнт" },
        { key: "phonenumber", label: "Номер телефону" },
        { key: "club_id", label: "Клуб" },
        { label: "Редагувати", key: "edit" },
      ],
      class: "",
      activErr: false,
      AlertText: "",
      currentRecord: null,
    };
  },
  watch: {
    date: function (newVal) {
      this.getVisitSchedule(newVal);
    },
  },
  async mounted() {
    this.date = moment().format("YYYY-MM-DD");
    await this.getVisitSchedule(this.date);
  },
  methods: {
    ...mapActions(["logOutUser"]),
    async getVisitSchedule(date) {
      await this.$api.facilities.getSchedule(date).then((response) => {
        this.schedule = response.data;
      });
    },
    updatePage(status) {
      if (status) {
        this.showModalCreate("Запис успішно додано", "green");
      } else {
        this.showModalCreate("Щось пішло не так", "red");
      }
      this.getVisitSchedule(this.date);
    },
    openPatcher(visit) {
      this.currentRecord = visit;
      this.$bvModal.show("modal-facility-patcher");
    },
    showModalCreate(text, color) {
      this.activErr = true;
      this.class = color;
      this.AlertText = text;
      setTimeout(() => {
        this.activErr = false;
      }, 4000);
    },
  },
  filters: {
    moment: function (date) {
      return moment(date).locale("uk").format("HH:mm");
    },
    toClub: function (club_id) {
      return club_id === 1 ? "Василенко, 9" : "Острозького, 55";
    },
  },
};
</script>

<style scoped></style>
